<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title"><template v-if="subject">{{subject.name}}</template> - 多栏账</span>
				<div class="float-right">
					<Button size="s" icon="fa fa-print" @click="printPage">打印</Button>
					<Button size="s" icon="fa fa-download" @click="exportExcel">导出</Button>
				</div>
		</div>
		<div class="margin-right-left margin-top">
			<div class="h-input-group" v-width="350">
				<DatePicker v-model="params.start" style="width: 140px" :clearable="false" :option="{end:params.end}"
							format="YYYY-MM-dd"></DatePicker>
				<span class="h-input-addon">至</span>
				<DatePicker v-model="params.end" style="width: 140px" :clearable="false" :option="{start:params.start}"
							format="YYYY-MM-dd"></DatePicker>
			</div>
			<div class="float-right">
				<Button color="primary" icon="fa fa-search" :loading="loading" @click="doSearch">查询</Button>
			</div>
		</div>
		<Row class="h-panel-body" type="flex" :space-x="10">
			<Cell :flex="1" style="overflow-x: auto;">
				<table id="ioTable" class="cus-table">
					<thead class="header">
					<tr>
						<td>日期</td>
						<td>凭证字号</td>
						<td>摘要</td>
						<td>科目</td>
						<td>借方</td>
						<td>贷方</td>
						<td>方向</td>
						<td>余额</td>
					</tr>
					</thead>
					<tbody>
					<tr v-for="(item,index) in dataList" :key="index">
						<td>{{item.voucherDate}}</td>
						<td>{{item.voucherCode}}</td>
						<td>{{item.summary}}</td>
						<td>{{item.subjectName}}</td>
						<td class="text-right">{{item.debitAmount|numFormat}}</td>
						<td class="text-right">{{item.creditAmount|numFormat}}</td>
						<td class="text-center">{{item.balanceDirection}}</td>
						<td class="text-right">{{item.balance|numFormat}}</td>
					</tr>
					<tr v-if="!dataList.length">
						<td colspan="8" class="text-center padding">暂无数据</td>
					</tr>
					</tbody>
				</table>
			</Cell>
			<Cell v-width="200">
				<Tree v-model="subjectId" @select="subjectSelect" :option="param" ref="subject" filterable selectOnClick className="h-tree-theme-row-selected"></Tree>
			</Cell>
		</Row>
	</app-content>
</template>

<script>
	import ioMixin from '../../js/common/io-mixin';
	import manba from "manba";

	export default {
		name: "MultiColumnLedger",
		mixins: [ioMixin],
		data() {
			return {
				loading: false,
				param: {
					keyName: 'id',
					parentName: 'parentId',
					titleName: 'subjectFullName',
					dataMode: 'list',
					datas: []
				},
				dataList: [],
				subjectId: null,
				subject: null,
				params: {
					start: manba().startOf(manba.MONTH).format(),
					end: manba().endOf(manba.MONTH).format()
				}
			};
		},
		watch: {
			subject() {
				this.loadList();
			},
			'params.end'() {
				this.loadList();
			},
			'params.start'() {
				this.loadList();
			}
		},
		methods: {
			printPage() {
				this.doPrint({title: '多栏账', elId: 'ioTable', period: `${this.params.start} 至 ${this.params.end}`});
				},
			exportExcel() {
				this.doExport({name: '多栏账', elId: 'ioTable', period: `${this.params.start} 至 ${this.params.end}`});
				},
			loadSubject() {
				this.$api.accountbook.loadSubject({accountDate: this.params.end}).then(({data}) => {
					this.$set(this.param, "datas", data);
					if (data.length) {
						this.subjectId = data[0].id;
						this.subject = data[0];
					}
				});
			},
			doSearch() {
				this.loadList();
			},
			loadList() {
				if (!this.subject) {
					return;
				}
				this.loading = true;
				this.$api.accountbook.loadMultiColumnLedger({
					start: this.params.start,
					end: this.params.end,
					subjectCode: this.subject.code
				}).then(({data}) => {
					this.dataList = data;
					this.loading = false;
				});
			},
			subjectSelect(node) {
				this.subject = node;
			}
		},
		created() {
			this.loadSubject();
		}
	};
</script>

<style scoped lang="less">
	.cus-table {
		width: 100%;
		border-collapse: collapse;

		td {
			padding: 0 8px;
			border: 1px solid #e2e2e2;
			font-size: 12px;
			height: 32px;
		}

		tbody tr:nth-child(even) {
			background-color: #f8fbf8;
		}

		tbody tr:hover {
			background-color: #F0F6FF;
		}

		.header {
			td {
				background-color: #F5F5F5;
				text-align: center;
				font-weight: bold;
				height: 35px;
			}
		}
	}
</style>
